var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#1294F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_3730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5827 13.3374V20.0418C23.5827 20.5838 23.3756 21.1054 23.0038 21.4997C22.6319 21.8941 22.1234 22.1314 21.5823 22.1632L21.4577 22.1668H11.541C10.999 22.1668 10.4774 21.9597 10.0831 21.5879C9.68872 21.216 9.45136 20.7075 9.41956 20.1664L9.41602 20.0418V13.3374L16.1062 17.7978L16.1884 17.8445C16.2852 17.8918 16.3916 17.9164 16.4993 17.9164C16.6071 17.9164 16.7135 17.8918 16.8103 17.8445L16.8925 17.7978L23.5827 13.3374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4589 10.8333C22.2239 10.8333 22.8947 11.237 23.2687 11.844L16.5005 16.3561L9.73242 11.844C9.91002 11.5556 10.154 11.3138 10.4441 11.1388C10.7341 10.9638 11.0618 10.8608 11.3998 10.8382L11.5422 10.8333H21.4589Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_3730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/MailLogo.b52718e421d3063c429814a9839d6513.svg";
export { ForwardRef as ReactComponent };